export default __webpack_public_path__ + "images/geo-chart-dummy-140.c4eb70f6672b3c868153e5bb7833291b.svg";